export const VERSION = '1.1.6'

let API_URI=''
let CLIENT_URL=''

let ENV=process.env.REACT_APP_PROJECT_ENV

if(ENV==='DEV'){
    API_URI='http://localhost:8001'
    CLIENT_URL='http://localhost:3000'
}else{
    API_URI=''
    CLIENT_URL='https://icms.identitech.com.au'
}

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

export {
    API_URI,
    CLIENT_URL,
    ENV
}